/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Name_LabelInputs */

const en_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Name`)
};

const fr_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la clé`)
};

const de_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüsselname`)
};

const it_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome chiave`)
};

const ru_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя ключа`)
};

const es_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la clave`)
};

const zh_cn2_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`键名`)
};

const ja_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キー名`)
};

const hi_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी नाम`)
};

const pt_pt2_options_api_keys_name_label = /** @type {(inputs: Options_Api_Keys_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da chave`)
};

/**
* | output |
* | --- |
* | "Key Name" |
*
* @param {Options_Api_Keys_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_name_label = /** @type {((inputs?: Options_Api_Keys_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_name_label(inputs)
	if (locale === "de") return de_options_api_keys_name_label(inputs)
	if (locale === "it") return it_options_api_keys_name_label(inputs)
	if (locale === "ru") return ru_options_api_keys_name_label(inputs)
	if (locale === "es") return es_options_api_keys_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_name_label(inputs)
	if (locale === "ja") return ja_options_api_keys_name_label(inputs)
	if (locale === "hi") return hi_options_api_keys_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_name_label(inputs)
	return en_options_api_keys_name_label(inputs)
});